/**
 * Profile Articles store
 */
import { getPersistedValue } from '@/helpers/store.js';

const maxAge = 172800000; // 48 hours (2 days) [msec]

const initialState = () => ({
    published: [],
    preliminary: [],
    archived: [],
    timestamps: {}
});

const createStore = (Vue) => {

    const state = initialState;

    const getters = {
        getProfileArticles (state) {
            return {
                published: state.published || [],
                preliminary: state.preliminary || [],
                archived: state.archived || []
            };
        }
    };

    const actions = {

        /**
         * Fetch User Profile Articles, three categories.
         */
        async fetchProfileArticles ({ commit, state }) {
            // check persisted localStorage
            let published = getPersistedValue(state, 'published', maxAge);
            let preliminary = getPersistedValue(state, 'preliminary', maxAge);
            let archived = getPersistedValue(state, 'archived', maxAge);

            if (!published) {
                await Vue.prototype.$SVC.getProfileFeatureArticles('published')
                    .then((response) => {
                        published = response && response.data && response.data.Results;
                        commit('setPublished', published);
                    })
                    .catch(Promise.reject);
            }

            if (!preliminary) {
                await Vue.prototype.$SVC.getProfileFeatureArticles('preliminary', {UseScope: 'IncludePrereleaseAndBin'})
                    .then((response) => {
                        preliminary = response && response.data && response.data.Results;
                        commit('setPreliminary', preliminary);
                    })
                    .catch(Promise.reject);
            }

            if (!archived) {
                await Vue.prototype.$SVC.getProfileFeatureArticles('archived')
                    .then((response) => {
                        archived = response && response.data && response.data.Results;
                        commit('setArchived', archived);
                    })
                    .catch(Promise.reject);
            }

            const value = {published, preliminary, archived};
            return Promise.resolve(value);
        }
    };

    const mutations = {
        RESET (state) {
            const newState = initialState();
            Object.keys(newState).forEach((key) => {
                state[key] = newState[key];
            });
        },

        setPublished (state, value) {
            state.published = value;
            state.timestamps.published = new Date();
        },

        setPreliminary (state, value) {
            state.preliminary = value;
            state.timestamps.preliminary = new Date();
        },

        setArchived (state, value) {
            state.archived = value;
            state.timestamps.archived = new Date();
        }
    };

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations
    };
};

export default app => createStore(app);
